//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import PurchaseOrderCreateView from '@/views/Purchase/PchPurchaseOrder/create'
import PurchaseOrderEmittedView from '@/views/Purchase/PchPurchaseOrder/emitted'
import PurchaseOrderListView from '@/views/Purchase/PchPurchaseOrder/list'
import PurchaseOrderPendingView from '@/views/Purchase/PchPurchaseOrder/pending'
import PurchaseOrderReceptionView from '@/views/Purchase/PchPurchaseOrder/reception'
import PurchaseOrderRectifyView from '@/views/Purchase/PchPurchaseOrder/rectify'
import PurchaseOrderUpdateView from '@/views/Purchase/PchPurchaseOrder/update'

//
export default {
    path: 'purchase_orders',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'purchase-order-list',
            component: PurchaseOrderListView,
        },
        {
            path: 'create',
            name: 'purchase-order-create',
            component: PurchaseOrderCreateView,
            meta: {
                title: 'Crear',
            },
        },
        {
            path: 'emitted',
            name: 'purchase-order-emitted',
            component: PurchaseOrderEmittedView,
            meta: {
                title: 'Ordenes de compra emitidas',
            },
        },
        {
            path: 'historic',
            name: 'purchase-order-historic',
            component: PurchaseOrderListView,
            props: {
                tableParams: {
                    paramFilter: {
                        pch_purchase_order_state_id: [6],
                    },
                },
            },
            meta: {
                title: 'Ordenes de compra emitidas',
            },
        },
        {
            path: 'pending',
            name: 'purchase-order-pending',
            component: PurchaseOrderPendingView,
            meta: {
                title: 'Ordenes de compra pendientes',
            },
        },
        {
            path: ':id',
            name: 'purchase-order-update',
            component: PurchaseOrderUpdateView,
            meta: {
                title: 'Datos de orden de compra',
            },
        },
        {
            path: ':id/reception',
            name: 'purchase-order-reception',
            component: PurchaseOrderReceptionView,
            meta: {
                title: 'Recepción de orden de compra',
            },
        },
        {
            path: ':id/rectify',
            name: 'purchase-order-rectify',
            component: PurchaseOrderRectifyView,
            meta: {
                title: 'Rectificar precios de orden de compra',
            },
        },
    ],
    meta: {
        title: 'Ordenes de compra',
    },
}
